/* eslint-disable no-use-before-define */
import { cleanObject, arrayFrom, formatDate } from '../../twd'

export const toSearchParams = ({
    invType,
    corpSectors,
    muniStates, muniPurposes, muniGeneralObligation, muniRevenue, muniTaxExempt, muniTaxable,
    cdBlueSky, cdNewIssue, cdSecondary,
    agencyTypes,
    treasuryTypes,
    holdMaturityMin, holdMaturityMax,
    quantityMin, quantityMax,
    offerYtwMin, offerYtwMax,
    clientPriceMin, clientPriceMax,
    holdMoodyRatingMin, holdMoodyRatingMax,
    holdSpRatingMin, holdSpRatingMax,
    holdCallableInd,
    holdRatingAndOr,
}) => {

    let p = {
        holdInvType: [invType],
        holdRatingAndOr,
        holdUnderlyingRating: 'NO',
        offeringType: ['ask-side'],
        holdMaturityMin: formatDate(holdMaturityMin),
        holdMaturityMax: formatDate(holdMaturityMax, true),
        quantityMin, quantityMax,
        offerYtwMin, offerYtwMax,
        ytwMin: offerYtwMin,
        ytwMax: offerYtwMax,
        clientPriceMin, clientPriceMax,
    }

    let isCorp = invType==='C'
    let isMuni = invType==='M'
    let isCD = invType==='S'
    let isTreasury = invType==='T'
    let isAgency = invType==='A'
    let hasRating = !(isCD || isTreasury)

    if (isCorp) {
        Object.assign(p, getParams(corpSectors))
    }
    else if (isMuni) {
        Object.assign(p, getParams(muniStates, muniPurposes))

        p.holdMuniType = []
        if (muniGeneralObligation) p.holdMuniType.push('G')
        if (muniRevenue) p.holdMuniType.push('R')

        p.holdTaxable = []
        if (muniTaxable) p.holdTaxable.push('Y')
        if (muniTaxExempt) p.holdTaxable.push('N')
    }
    else if (isCD) {
        Object.assign(p, getParams(cdBlueSky))

        p.holdBlueSkyStateCD = arrayFrom(p.holdBlueSkyStateCD).filter(Boolean)
        p.primarySecondary = []
        if (cdNewIssue) p.primarySecondary.push('primary')
        if (cdSecondary) p.primarySecondary.push('secondary')
        p.offeringType = p.offeringType.concat(p.primarySecondary)
    }
    else if (isAgency) {
        Object.assign(p, getParams(agencyTypes))
    }
    else if (isTreasury) {
        Object.assign(p, getParams(treasuryTypes))
    }


    if (hasRating) {
        Object.assign(p, {
            holdMoodyRatingMin,
            holdMoodyRatingMax,
            holdSpRatingMin,
            holdSpRatingMax,
        })
        if (['AND','OR'].indexOf(holdRatingAndOr)<0) {
            p.holdRatingAndOr = holdRatingAndOr===true ? 'OR' : 'AND'
        }
    }

    if (!isTreasury && holdCallableInd) {
        p.holdCallableInd = ['N']
        p.holdCallFeatures = ['holdCallableInd-N']
    }

    return cleanObject(p)
}

const getParams = (...args) => {
    return args
    .reduce((x, a) => x.concat(arrayFrom(a)), [])
    .reduce((x, a) => {
        let [k,v] = a.split('=')
        if (!x[k]) x[k] = []

        let arr = x[k]
        let i = arr.indexOf(v)
        if (i<0) arr.push(v)

        return x
    }, {})
}


// WEBPACK FOOTER //
// ./src/overview/quick-screener/to-search-params.js